<template>

<div class="graph">

	<apexchart height="100%" :options="finalOptions" :series="finalData" />

</div>

</template>

<script>

export default {

	props: ['type', 'options', 'data'],

	data: function() {
	
		return {
			default: {
				all: {
					theme: {
						palette: 'palette3'
					},
					tooltip: {
						theme: 'light'
					}
				},
				stacked: {
					chart: {
						type: 'bar',
						stacked: true
					},
					dataLabels: {
						enabled: false
					}
				},
				sparkline: {
					chart: {
						type: 'area',
						sparkline: {
							enabled: true
						}
					},
					stroke: {
						curve: 'straight',
						width: 3
						
					},
					fill: {
						opacity: 0.25
					},
					yaxis: {
						min: 0
					},
					colors: ['#6da1ca']
				}
			}
		}
	
	},

	computed: {

		finalData: function() {

			if (this.$_.isObject(this.data) && !this.$_.isArray(this.data)) {

				return [this.data]
			
			} else {
			
				return (this.data[0].data) ? this.data : [{ data: this.data }]

			}
		
		},

		finalOptions: function() {

			var defaultOptions = this.$util.structure.merge(this.default.all, this.default[this.type] || {})
			var options = this.$util.structure.merge(this.options || {}, defaultOptions)

			if (options.yaxis === 'currency') {

				options.yaxis = {}
			
				options.tooltip = {
					y: {
						formatter: function(value) {
						
							return '$' + value.toFixed(2)

						}
					}
				}

			}

			return options
		
		}
	
	}

}

</script>

<style scoped>

</style>
